import { Injectable } from '@angular/core';
import { Stripe, StripeCardElement, StripeElements, StripeCardElementOptions, Token, StripeError } from '@stripe/stripe-js';

//environment
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class StripeClientService {
  private stripePromise: Promise<Stripe>;

  constructor(
    private _environmentService: EnvironmentService
  ) {
    this.stripePromise = this.loadStripe(this._environmentService.getFacilityConfig().stripe.publishedKey, this._environmentService.getStripeAccountId());
  }

  private loadStripe(publishableKey: string, accountId: string): Promise<Stripe> {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.onload = () => {
        resolve((window as any).Stripe(publishableKey, {
          stripeAccount: accountId
        }));
      };
      document.body.appendChild(script);
    });
  }

  elements(options?: StripeCardElementOptions): Promise<StripeElements> {
    return this.stripePromise.then((stripe) => stripe.elements());
  }

  createToken(card: StripeCardElement): Promise<{ token?: Token; error?: StripeError }> {
    return this.stripePromise.then((stripe) => stripe.createToken(card));
  }
}
